export default __webpack_public_path__ + "static/media/WhiteLoader.f80b748f.gif";